module.exports = __webpack_public_path__ + "static/img/bg-2.ae5dced2.png";